import { analyticsContract } from './analytics.js';
import { authContract } from './auth.js';
import { catalogContract, collectionsContract, playbackContract, youTubeContract, } from './catalog.js';
import { childrenContract } from './children.js';
import { commandsContract, deviceStateContract } from './commands.js';
import { deviceConfigContract } from './device-config.js';
import { devicesContract, pairingContract } from './devices.js';
import { healthContract } from './health.js';
import { importsContract } from './imports.js';
import { sessionsContract } from './sessions.js';
export * from './analytics.js';
export { authContract, currentUserSchema, passwordSchema, REFRESH_COOKIE_NAME, REFRESH_COOKIE_PATH, sessionSchema, } from './auth.js';
export { catalogContract, collectionSchema, collectionsContract, contentItemSchema, playbackContract, playbackDescriptorSchema, youTubeContract, } from './catalog.js';
export { childrenContract, childWithProfileSchema } from './children.js';
export { commandsContract, deviceStateContract, remoteCommandSchema, } from './commands.js';
export { deviceConfigContract } from './device-config.js';
export { devicesContract, pairingContract } from './devices.js';
export { healthContract } from './health.js';
export { IMPORT_INSPECT_LIMIT, importCandidateSchema, importChoiceSchema, importHeldCopySchema, importJobItemSchema, importJobSchema, importSourceSchema, importsContract, RECENT_IMPORT_SOURCES_LIMIT, recentImportSourceSchema, } from './imports.js';
export { gateDecisionSchema, liveDeviceStateSchema, sessionsContract, } from './sessions.js';
export { API_VERSION } from './version.js';
/**
 * The complete HTTP surface of the backend.
 *
 * This object is the agreement between everyone working on the product. The
 * backend is checked against it at compile time and both applications derive
 * their clients from it, so an endpoint cannot drift from its consumers without
 * the build failing.
 *
 * It is also the coordination seam: parallel work stays safe precisely because
 * this is settled first and changed by one person at a time. See
 * `CLAUDE.md → Parallel work`.
 *
 * Three audiences, deliberately separated by how they authenticate:
 *
 * - `pairing` — unauthenticated. A tablet has no credential before it is paired.
 * - `device` — the scoped device token, and nothing else.
 * - everything else — a parent access token.
 */
export const apiContract = {
    health: healthContract,
    auth: authContract,
    children: childrenContract,
    devices: devicesContract,
    pairing: pairingContract,
    device: deviceConfigContract,
    sessions: sessionsContract,
    commands: commandsContract,
    deviceState: deviceStateContract,
    catalog: catalogContract,
    collections: collectionsContract,
    playback: playbackContract,
    youtube: youTubeContract,
    imports: importsContract,
    analytics: analyticsContract,
};
//# sourceMappingURL=index.js.map